export const MS_DAY = 86400000;

export const DAYS_MIN_FOR_MONTHLY_TEXT = 90;
export const MONTH_DAYS = 30;
export const YEAR_DAYS = 365;
export const YEAR_MONTHS = 12;

export const LIFETIME_DAYS = YEAR_DAYS * 5;
